import "../../../styles/progressBar.scss";

import PropTypes from "prop-types";
import React from "react";

export default class ProgressBar extends React.PureComponent {
    constructor(props){
        super(props);
    }

    render() {
        const {
            progress,
        } = this.props;
        const x = progress;
        //för att se kurvan googla på y=(-(x*x)+(2*x))*(1-x)+(x*x) och zooma in på x=[0,1] y=[0,1]
        const percentage = (-(x*x)+(2*x))*(1-x)+(x*x);
        //const percentage = progress;//y=x
        const color = progress<=1/24?"progressbar-progress-red": (progress<=4/24?"progressbar-progress-yellow":"progressbar-progress-green");

        return (
            <div className="progressbar-wrapper">
                <div className="progressbar-empty">
                    <div className={`${color} glow`} style={{width:`${percentage*100.0}%`}}></div>
                </div>
            </div>
        );
    }
}

ProgressBar.propTypes = {
    //value range [0.0, 1.0]
    progress: PropTypes.number.isRequired,
};

ProgressBar.defaultProps = {
};